import { InvoiceDisplayedType } from '../enums/invoiceDisplayedType'

export const invoiceDisplayedTypeToTitleKey: Record<InvoiceDisplayedType, string> = {
  [InvoiceDisplayedType.Invoice]: 'invoices.table.column.document_type.invoice',
  [InvoiceDisplayedType.CreditNote]: 'invoices.table.column.document_type.credit_note',
  [InvoiceDisplayedType.DepositInvoice]: 'invoices.table.column.document_type.deposit_invoice',
  [InvoiceDisplayedType.FinalInvoice]: 'invoices.table.column.document_type.final_invoice',
}
